import React from 'react';
import { InputField } from '../UI/InputField';
import { TextArea } from '../UI/TextArea';
import { CalendarIcon, LinkIcon } from 'lucide-react';
export const Step3ProjectInfo = ({
  formData,
  handleInputChange,
  errors,
  touched,
  setTouched
}) => {
  return <div className="mt-4 space-y-6" data-id="element-133">
      <InputField id="gewenste-uitvoerdatum" label="Gewenste uitvoerdatum" type="date" value={formData.projectInfo.gewensteUitvoerdatum} onChange={e => handleInputChange('projectInfo', 'gewensteUitvoerdatum', e.target.value)} icon={<CalendarIcon className="h-4 w-4" data-id="element-135" />} premium={true} data-id="element-134" />
      <TextArea id="project-omschrijving" label="Projectomschrijving" placeholder="Beschrijf uw project zo gedetailleerd mogelijk..." value={formData.projectInfo.projectOmschrijving} onChange={e => handleInputChange('projectInfo', 'projectOmschrijving', e.target.value)} rows={5} premium={true} data-id="element-136" />
      <InputField id="link-fotos" label="Link naar foto's (optioneel)" placeholder="Bijv. Google Drive of WeTransfer link" value={formData.projectInfo.linkNaarFotos} onChange={e => handleInputChange('projectInfo', 'linkNaarFotos', e.target.value)} helperText="U kunt hier een link toevoegen naar foto's van uw project" icon={<LinkIcon className="h-4 w-4" data-id="element-138" />} premium={true} data-id="element-137" />
    </div>;
};